export function getTwoLevelObjectPopulatedKeys(params: object) {
  if (!params) {
    return [];
  }
  const finalKeys: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (!value) {
      continue;
    }

    finalKeys.push(key);
    if (typeof value === 'object') {
      for (const [subKey, secondValue] of Object.entries(value)) {
        if (!secondValue) {
          continue;
        }

        finalKeys.push(`${key}.${subKey}`);
      }
    }
  }

  return finalKeys;
}

export function convertTargetProviderToWritebackTargetProvider(updatableTargetProvider) {
  const { facility, ...targetProvider } = updatableTargetProvider;
  return {
    ...targetProvider,
    ...(facility
      ? {
          organization: {
            address: facility.address,
            name: facility.name,
            contact_info: facility.contact_info,
          },
        }
      : {}),
    specialty: targetProvider?.specialty?.map((s) => ({ description: s })),
  };
}
